/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Observable, timer } from 'rxjs';
import { bufferToggle, throttleTime } from 'rxjs/operators';

export const bufferTimeToggledOnValue = (time: number) => (source$: Observable<any>) =>
  source$.pipe(bufferToggle(source$.pipe(throttleTime(time)), () => timer(time)));
